var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "property" }, [
    _vm.mode === 0
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.name))]),
          _vm.hasValue ? _c("span", [_vm._v(":")]) : _vm._e(),
          _vm.hasValue
            ? _c(
                "span",
                {
                  staticClass: "value",
                  class: _vm.values[0][1] === 1 ? "augmented" : ""
                },
                [_vm._v(" " + _vm._s(_vm.values[0][0]))]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm.mode === 3
      ? _c("div", [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.replaced) } })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
/* hot reload */
if (module.hot) {
  var api = require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (module.hot.data) {
      require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js").rerender('235aae65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    }
  }
}export { render, staticRenderFns }